import { render, staticRenderFns } from "./HotelExpense.vue?vue&type=template&id=2684332e&"
import script from "./HotelExpense.vue?vue&type=script&lang=js&"
export * from "./HotelExpense.vue?vue&type=script&lang=js&"
import style0 from "./HotelExpense.vue?vue&type=style&index=0&id=2684332e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports